import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

interface IContractDocsVersion
{
    id: number,
    text: string
    version: string,
    contractDocsId: number,
    createdAt: Date,
    updatedAt?: Date
}
export type ContractDocsVersionType = IContractDocsVersion;

class ContractDocsService
{
    public getLastVersion = async (contractDocsName: string): Promise<ContractDocsVersionType> => {
        let url: string = `${proxyUrl}/contractDocs/${contractDocsName}/lastVersion`;
        const req = await axios.get<any>(url);
        return req.data;
    }

    public getContractVersionById = async (idContractVersion: string): Promise<ContractDocsVersionType> => {
        let url: string = `${proxyUrl}/contractDocs/version/${idContractVersion}`;
        const req = await axios.get<any>(url);
        return req.data;
    }
}

const contractDocs = new ContractDocsService();
export default contractDocs;